const escapeFilterValue = value => `"${String(value).replace(/"/g, '\\"')}"`;

/**
 * Builds the Algolia `filters` string for the category page.
 *
 * These base constraints (category, ready-to-ship, sidebar facets) must live in
 * `filters` rather than `Configure.facetFilters`. When a color is selected the
 * `option_color` refinementList widget generates its own `facetFilters`, which
 * fully overrides any `facetFilters` set via Configure (dropping the category).
 * The `filters` string is an independent parameter, so it merges cleanly with
 * the color refinement and is also applied to the disjunctive facet-count query.
 */
const buildCategoryAlgoliaConfigureFilters = ({
  slug,
  isReadyToShipActive,
  selectedFacets,
}) => {
  const parts = [];

  if (slug) {
    parts.push(`categories:${escapeFilterValue(slug)}`);
  }

  if (isReadyToShipActive) {
    parts.push('is_in_stock:true');
  }

  Object.entries(selectedFacets || {}).forEach(([attr, values]) => {
    if (values?.size > 0) {
      const valueFilters = [...values].map(
        value => `${attr}:${escapeFilterValue(value)}`
      );
      parts.push(
        valueFilters.length === 1
          ? valueFilters[0]
          : `(${valueFilters.join(' OR ')})`
      );
    }
  });

  return parts.length > 0 ? parts.join(' AND ') : undefined;
};

export default buildCategoryAlgoliaConfigureFilters;
